// extracted by mini-css-extract-plugin
export var pageDuelCtas = "ContentfulBlockDuelImageCtas-module--pageDuelCtas--Vr5Lr";
export var imgWrapper = "ContentfulBlockDuelImageCtas-module--imgWrapper--YAYX1";
export var ctaWrapper = "ContentfulBlockDuelImageCtas-module--ctaWrapper--DsC1v";
export var body = "ContentfulBlockDuelImageCtas-module--body--9ib8L";
export var cta = "ContentfulBlockDuelImageCtas-module--cta--RioW6";